import { render, staticRenderFns } from "./TableMultipleSelected.vue?vue&type=template&id=f5bad564&"
import script from "./TableMultipleSelected.vue?vue&type=script&lang=js&"
export * from "./TableMultipleSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports